import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { Link } from '@mui/docs/Link';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TableOfContentsBanner() {
  return /*#__PURE__*/_jsxs(Link, {
    href: "https://war.ukraine.ua/support-ukraine/",
    target: "_blank",
    sx: [function (theme) {
      return {
        mt: 2,
        mx: 0.5,
        mb: 2,
        p: 1,
        pl: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        border: '1px solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderRadius: 1,
        transitionProperty: 'all',
        transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
        transitionDuration: '150ms',
        '&:hover, &:focus-visible': {
          backgroundColor: (theme.vars || theme).palette.primary[50],
          borderColor: (theme.vars || theme).palette.primary[200]
        }
      };
    }, function (theme) {
      return theme.applyDarkStyles({
        backgroundColor: alpha(theme.palette.primary[900], 0.2),
        '&:hover, &:focus-visible': {
          backgroundColor: alpha(theme.palette.primary[900], 0.4),
          borderColor: (theme.vars || theme).palette.primary[900]
        }
      });
    }],
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        borderRadius: '3px',
        overflow: 'auto',
        width: 'fit-content',
        flexShrink: 0
      },
      children: [/*#__PURE__*/_jsx(Box, {
        sx: {
          height: 6,
          width: 16,
          backgroundColor: '#0057B7'
        }
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          height: 6,
          width: 16,
          backgroundColor: '#FFD700'
        }
      })]
    }), /*#__PURE__*/_jsx(Typography, {
      component: "span",
      variant: "caption",
      sx: {
        fontWeight: 'medium',
        color: 'text.secondary'
      },
      children: "MUI stands in solidarity with Ukraine."
    })]
  });
}